import allImgPaths from 'assets/images';
import CustomDropdown from 'components/common/dropdown/Dropdown'
import CustomCheckBox from 'components/CustomCheckBox';
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { COMPARE_KEYS, RFP_FILTERS } from 'utils/constant';
import RfpDataTable from './RfpDataTable';
import { getDocumentForComparison } from 'services/event';
import { useParams } from 'react-router-dom';
import { cloneDeep, isArray } from 'lodash';
import Highlight from './Highlights';
import RfpTextBox from './RfpTextBox';
import RfpTabularBox from './RfpTabularBox';

const RfpCompare = ({ messageData = {} }: any) => {
    const { id: eventId } = useParams();
    const [documentsData, setDocumentsData] = useState<any>([])
    const [extractedDataKeys, setExtractedDataKeys] = useState<any>([]);
    const [extractedData, setExtractedData] = useState<any>([]);
    const [isCompare, setIsCompare] = useState(false)
    const [compareKeys, setCompareKeys] = useState<any>(COMPARE_KEYS)
    const {
        control
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            teamEmail: { value: "", label: "" },
            assignTask: { value: "", label: "" }
        }
    });

    useEffect(() => {
        fetchDocumentsData()
    }, [])

    const fetchDocumentsData = async () => {
        const payload = {
            event_id: eventId,
            type: 'compare'
        }
        const { data } = await getDocumentForComparison(payload);
        const updatedData = setData(data);

        // console.log({ data: updatedData })
        setDocumentsData(updatedData)
    }

    const setData = (data: any[]) => {
        if (data?.length) {
            let clonedData = cloneDeep(data);
            clonedData = clonedData.map((item: any) => ({ ...item, checked: false }));
            return clonedData
        } else {
            return []
        }
    }

    const [selectedValue, setSelectedValue] = useState<any>(null);

    const CustomPlaceholder = () => (
        <div className="flex items-center justify-between gap-x-2">
            <img src={allImgPaths.filterIcon} alt="" />
            <span className="text-[#344054] font-interSemiBold" >Filter for</span>
        </div>
    );

    // const handleSelection = (name: string, isChecked: boolean) => {
    //     console.log({ name, isChecked })
    //     let clonedData = cloneDeep(documentsData);
    //     const index = clonedData.findIndex((co: any) => co.file_name == name);
    //     console.log({ index })
    //     if (index > -1) {
    //         clonedData[index]['checked'] = isChecked;
    //         console.log({ clonedData })
    //         setDocumentsData(clonedData)
    //     }
    // }

    const handleSelection = (index: number, isChecked: boolean) => {
        let clonedData = cloneDeep(documentsData);
        clonedData[index]['checked'] = isChecked;
        setDocumentsData(clonedData)

        const totalSelected = clonedData.filter((dt: any) => dt.checked);

        if (totalSelected?.length > 3) {
            clonedData[index]['checked'] = false;
            setDocumentsData(clonedData)
            handleCompare()
        }

        setIsCompare(false)
    }

    const handleCompare = () => {
        const selections = documentsData.filter((dt: any) => dt.checked);
        if (selections.length > 0) {
            createExtractedData(selections)
            setIsCompare(true)
        }
    }

    const createExtractedData = (data: any[]) => {
        const extractions = data.map((dt: any) => dt.extracted_data);
        setExtractedData(extractions)

        const uniqueKeys = new Set();
        extractions.forEach(item => {
            Object.keys(item).forEach(key => uniqueKeys.add(key));
        });
        const uniqueKeysArray = Array.from(uniqueKeys);
        let finalKeysData: any[] = []

        for (let index = 0; index < uniqueKeysArray.length; index++) {
            const element: any = uniqueKeysArray[index];

            if (element != 'name' && element != 'contact_email' && element != 'contact_phone' && element != 'address') {
                finalKeysData.push({
                    key: element,
                    value: compareKeys[element]
                })
            }
        }

        // setExtractedDataKeys(finalKeysData)

        // console.log({ keysData: finalKeysData, selectedData: extractions })
        const filteredKeys = returnNull(finalKeysData, extractions);
        // console.log({ filteredKeys })
        setExtractedDataKeys(filteredKeys)
    }

    const returnNull = (keysArray: any, dataArray: any) => {
        return keysArray.filter((keyObj: any) => {
            const key = keyObj.key;
            return dataArray.some((dataObj: any) => dataObj[key] !== null && dataObj[key] !== '' && dataObj[key] !== undefined);
        });
    }



    const convertNewlinesToBreaks = (text: any) => {
        if (!text) {
            return ''
        } else {
            if (typeof text == 'number') text = text.toString()
            if (typeof text == 'string') {
                return text.split('\n').map(line => `<div class="line">${line}</div>`).join('');
            } else {
                return ''
            }
        }
    }

    return (
        <>
            {
                documentsData?.length > 0 &&
                <>
                    <div className="mb-10">
                        <div className='flex gap-x-3 items-center justify-between mb-2.5'>
                            <span className='font-interMedium'>Select Up to 3 Quotes for Comparison</span>

                            <div className='flex gap-x-3 items-center'>
                                <button className=" text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide !text-base flex items-center bg-white home-dropdown rfp-dropdwon">
                                    <CustomDropdown
                                        name="rfp_fiter"
                                        control={control}
                                        placeholder={<CustomPlaceholder />}
                                        selectedValue={selectedValue}
                                        onChange={() => { }}
                                        options={RFP_FILTERS}
                                    />
                                </button>

                                <div className="border border-[#D0D5DD] rounded-lg w-60 py-2 px-3.5 flex items-center gap-x-2">
                                    <img src={allImgPaths.searchIcon} alt="search" />
                                    <input
                                        className="w-full"
                                        placeholder="Search for Vendor"
                                        type="text"
                                        onChange={() => { }}
                                        value={''}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="border border-[#EAECF0] rounded-tl-xl rounded-tr-xl">
                            <div className="bg-[#F2F4F7] rounded-tl-xl rounded-tr-xl custom-rfp-table-grid">
                                <div className="flex items-center gap-x-4 py-3 px-6">
                                    <span className='text-sm font-interMedium text-[#475467] ml-8'>Vendor</span>
                                </div>

                                {/* <div className="py-3 px-6">
                                    <span className='text-sm font-interMedium text-[#475467]'>Total Interactions</span>
                                </div> */}

                                <div className="py-3 px-6">
                                    <span className='text-sm font-interMedium text-[#475467]'>Service categories</span>
                                </div>
                            </div>
                            <div className="overflow-y-scroll max-h-52">
                                {
                                    documentsData?.length > 0 && documentsData.map((item: any, index: any) => (
                                        <div className="custom-rfp-table-grid border-b border-[#EAECF0]" key={index}>
                                            <div className="flex items-center gap-x-4 py-3 px-6">
                                                <input
                                                    type="checkbox"
                                                    id={item?.file_name || ''}
                                                    name={item?.file_name || ''}
                                                    onChange={(e: any) => handleSelection(index, e.target.checked)}
                                                    checked={item?.checked || false}
                                                    className='w-4 h-4 cursor-pointer'
                                                />

                                                <div className="flex gap-x-3">
                                                    <div className="">
                                                        <p className='text-sm font-interMedium text-[#475467] mb-0.5'>
                                                            {item.file_name}
                                                        </p>
                                                        {/* <p className='text-sm text-[#475467]'>{item.size}</p> */}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="py-3 px-6 flex items-center pl-20">
                                                <span className='text-sm text-[#475467]'>2</span>
                                            </div> */}

                                            <div className="py-3 px-7 flex items-center">
                                                {
                                                    item?.rfp_categories && isArray(item?.rfp_categories) &&
                                                    <span className='text-sm text-[#475467]'>
                                                        {item.rfp_categories.join(', ')}
                                                    </span>
                                                }
                                                {
                                                    !item?.rfp_categories?.length && <span>-</span>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                            <div className="flex justify-end my-3 w-full pr-2">
                                <button className='submit-btn-blue !px-5' onClick={handleCompare}>Compare</button>
                            </div>
                        </div>
                    </div>
                    {/* <div>
                        {
                            isCompare && documentsData.map((item: any, index: number) => (
                                <React.Fragment key={index}>
                                    {
                                        item.checked &&
                                        <div className='mt-5'>
                                            <strong>{item?.file_name}</strong><span>'s quote </span>
                                            <div className="border border-[#D0D5DD] rounded-lg px-6 py-5 mt-3">
                                                {
                                                    item?.extracted_data
                                                    && Object.keys(item?.extracted_data)?.length > 0
                                                    && Object.keys(item?.extracted_data).map((ed: any, edIndex: number) => (
                                                        <React.Fragment key={edIndex}>
                                                            {
                                                                item.extracted_data[ed] &&
                                                                <p className='text-[#101828] text-base pb-4'>
                                                                    {
                                                                        typeof item.extracted_data[ed] == 'string' &&
                                                                        <>
                                                                            <span className='capitalize font-interSemiBold'>{ed}</span>: <span>{item.extracted_data[ed]}</span>
                                                                        </>
                                                                    }
                                                                    {
                                                                        (typeof item.extracted_data[ed] == 'object' && !isArray(item.extracted_data[ed])) &&
                                                                        Object.keys(item?.extracted_data[ed]).map((edo: any, edoIndex: number) => (
                                                                            <span key={edoIndex}>
                                                                                {
                                                                                    typeof item.extracted_data[ed][edo] == 'string' &&
                                                                                    <span>
                                                                                        <span className='capitalize font-interSemiBold'>{edo}</span>: <span>{item.extracted_data[ed][edo]}</span>
                                                                                    </span>
                                                                                }
                                                                            </span>
                                                                        ))
                                                                    }
                                                                    {
                                                                        isArray(item.extracted_data[ed]) &&
                                                                        <>
                                                                            <span className='capitalize font-interSemiBold'>{ed}</span>: <span>{item.extracted_data[ed].join(',')}</span>
                                                                        </>
                                                                    }
                                                                </p>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            ))
                        }
                    </div> */}
                </>
            }

            {
                isCompare && extractedDataKeys?.length &&
                <>
                    <div className="border border-[#D0D5DD] rounded-lg px-6 py-5 mt-3">
                        <div className="border border-[#EAECF0] rounded-tl-xl rounded-tr-xl">
                            <div className="bg-[#F2F4F7] rounded-tl-xl rounded-tr-xl custom-rfp-tabular-grid">
                                <div className="flex items-center gap-x-4 py-3 px-6">
                                    <span className='text-sm font-interMedium text-[#475467]'>Criteria</span>
                                </div>

                                {
                                    extractedData.map((ed: any, edIndex: number) => (
                                        <div className="py-3 px-6" key={edIndex}>
                                            <span className='text-sm font-interMedium text-[#475467]'>
                                                {ed.name}
                                            </span>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="overflow-y-scroll max-h-[640px]">
                                {
                                    extractedDataKeys.map((item: any, index: number) => (
                                        <div className="custom-rfp-tabular-grid border-b border-[#EAECF0]" key={index}>
                                            <div className="flex items-center gap-x-4 py-2 px-6">
                                                <p className='text-sm font-interMedium text-[#101828] mb-0.5'>{item.value}</p>
                                            </div>
                                            {
                                                extractedData.map((ed: any, edIndex: number) => (
                                                    <div className="py-2 px-6 flex items-center" key={edIndex}>
                                                        <span className='text-sm text-[#475467]'>
                                                            {
                                                                ed[item.key] &&
                                                                <>
                                                                    {
                                                                        (typeof ed[item.key] == 'string' || typeof ed[item.key] == 'number') &&
                                                                        // <span>{ed[item.key]}</span>
                                                                        <div className='' dangerouslySetInnerHTML={{ __html: convertNewlinesToBreaks(ed[item.key]) }}>

                                                                        </div>
                                                                    }
                                                                    {
                                                                        isArray(ed[item.key]) &&
                                                                        <div>
                                                                            <ul>

                                                                                {
                                                                                    ed[item.key].map((itm: any, itmIndex: number) => (
                                                                                        <li className='pb-1 text-sm text-[#475467]' key={itmIndex}>{itm}</li>
                                                                                    ))
                                                                                }
                                                                            </ul>
                                                                        </div>
                                                                    }
                                                                </>
                                                            }
                                                            {
                                                                !ed[item.key] && <span>-</span>

                                                            }
                                                        </span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    ))
                                }
                                <div className="flex justify-end my-3 w-full pr-2">
                                    <button className='submit-btn-blue !px-5'>Compare</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                documentsData?.length == 0 &&
                <div className='item-center justify-between my-5 pl-14 pr-5'>
                    <p>Nothing to Compare</p>
                </div>
            }
        </>
    )
}

export default RfpCompare